var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content_center"},[_c('el-result',{attrs:{"icon":"info","title":"页面未找到或无权访问"}},[_c('template',{slot:"extra"},[(_vm.$store.state.homePath)?_c('router-link',{staticStyle:{"color":"#3a8ee6","font-size":"16px"},attrs:{"to":"/","replace":""}},[_vm._v("返回首页")]):_vm._e()],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }